export default __webpack_public_path__ + "static/media/fx.0a320dd6.webp";